import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Feedback, FeedbackComplaint} from './feedback.model';

export const loadFeedbacks = createAction(
  '[Feedback/API] Load Feedbacks',
  props<{ feedbacks: FeedbackComplaint[] }>()
);

export const addFeedback = createAction(
  '[Feedback/API] Add Feedback',
  props<{ feedback: FeedbackComplaint }>()
);

export const upsertFeedback = createAction(
  '[Feedback/API] Upsert Feedback',
  props<{ feedback: FeedbackComplaint }>()
);

export const addFeedbacks = createAction(
  '[Feedback/API] Add Feedbacks',
  props<{ feedbacks: FeedbackComplaint[] }>()
);

export const upsertFeedbacks = createAction(
  '[Feedback/API] Upsert Feedbacks',
  props<{ feedbacks: FeedbackComplaint[] }>()
);

export const updateFeedback = createAction(
  '[Feedback/API] Update Feedback',
  props<{ feedback: Update<FeedbackComplaint> }>()
);

export const updateFeedbacks = createAction(
  '[Feedback/API] Update Feedbacks',
  props<{ feedbacks: Update<FeedbackComplaint>[] }>()
);

export const deleteFeedback = createAction(
  '[Feedback/API] Delete Feedback',
  props<{ id: string }>()
);

export const deleteFeedbacks = createAction(
  '[Feedback/API] Delete Feedbacks',
  props<{ ids: string[] }>()
);

export const clearFeedbacks = createAction(
  '[Feedback/API] Clear Feedbacks'
);

// CUSTOM ACTIONS
export const createFeedback = createAction(
  '[Feedback/API] Create Feedback',
  props<{ input: any }>()
);

export const transferFeedbackToEmrejesho = createAction(
  '[Feedback/API] Transfer Feedback to Emrejesho',
  props<{ input: any }>()
);

export const feedbackFollowupFromEmrejesho = createAction(
  '[Feedback/API] Feedback FollowUp From Emrejesho',
  props<{ feedbackUniqueId: string }>()
);

export const getAllFeedbacks = createAction(
  '[Feedback/API] Get All Feedbacks',
  props<{ filtering: {
      uniqueId?: string,
      serviceProvider?: string,
      serviceUniqueId?: string,
      pageNumber?: number
    } }>()
);

export const respondToServiceFeedback = createAction(
  '[Feedback/API] Respond To Service Feedback',
  props<{ input: { feedbackUniqueId?: string,feedbackResponse?: string} }>()
);

export const getMyServiceFeedbackComplaints = createAction(
  '[Feedback/API] Get MyService Feedback',
  props<{ filtering: {
    pageNumber: number, serviceProvider?: string, serviceUniqueId?: string, uniqueId?: string
  }
  }>()

)
